<div [style.height]="value"></div>
